import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "@/components/ui/toaster";

export default function MainLayout() {
  return (
    <div className="flex h-screen overflow-hidden" data-testid="main-layout">
      <Sidebar />
      <main className="relative flex-1 overflow-y-auto bg-background">
        <Outlet />
      </main>
      <Toaster />
    </div>
  );
}
